import { CircleAlert } from "lucide-react";

const WizardValidationBanner = ({ errors = [], className = "" }) => {
  const messages = [...new Set(errors.filter(Boolean))];
  if (!messages.length) return null;

  return (
    <div
      className={`rounded-lg border border-error-500/25 bg-error-50 px-4 py-3 ${className}`}
    >
      <div className="flex items-start gap-2">
        <CircleAlert
          size={16}
          className="mt-0.5 shrink-0 text-error-500"
          strokeWidth={2}
        />
        <div className="min-w-0">
          <p className="text-xs font-semibold text-error-500">
            Please fix the following required fields:
          </p>
          <ul className="mt-1.5 list-outside list-disc pl-4 text-xs text-error-500">
            {messages.map((message) => (
              <li key={message}>{message}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default WizardValidationBanner;
